import { render, staticRenderFns } from "./cityCfg.vue?vue&type=template&id=10cde548&scoped=true&"
import script from "./cityCfg.vue?vue&type=script&lang=js&"
export * from "./cityCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cde548",
  null
  
)

export default component.exports